import { Link } from 'react-router-dom';
import useBlockInspect from '../../hooks/useBlockInspect';
import { IMG, pageBg } from '../../data/santaStages';
import GameBanner from '../../components/GameBanner/GameBanner';
import './RulesPage.css';

export default function RulesPage() {
  useBlockInspect();

  return (
    <div className="santa-rules bg" style={pageBg('gamebg.jpg', 'bg1mob.jpg')}>
      <div className="container-fluid">
        <GameBanner />
        <div className="row">
          <div className="col-sm-5 col-md-5 col-lg-5 col-xs-12 auto">
            <img src={`${IMG}/storytop.png`} className="img-fluid desk" style={{ width: '100%' }} alt="" />
            <img src={`${IMG}/mobiletext.png`} className="img-fluid mob" style={{ width: '100%' }} alt="" />
          </div>
          <div className="col-sm-10 col-md-10 col-lg-10 col-xs-12 auto" style={{ marginTop: 10 }}>
            <div className="row">
              <div className="col-sm-11 col-md-11 col-lg-11 col-xs-12 auto">
                <div className="rule-title" style={{ textAlign: 'center' }}>WHAT CAN YOU DO?</div>
              </div>
            </div>
            <div className="row" style={{ marginTop: 0 }}>
              <div className="col-sm-9 col-md-9 col-lg-9 col-xs-12 auto">
                <div className="rule-text">
                  <ul>
                    <li>
                      Join the search party, put our heads together and find the kidnapper. But more
                      importantly, we need to find Santa! Who gives a pile of snowballs how we do it
                      - let&apos;s just do it!
                    </li>
                    <li>Trace down Santa&apos;s footsteps based on his last known location and time</li>
                    <li>Identify the kidnappers and rescue Santa so we can have Merry Christmas</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-2 col-md-2 col-lg-2 col-xs-12 auto">
            <Link to="/suspects">
              <div className="button-login" style={{ textAlign: 'center' }}>Next</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
